import { withSvgIcon } from './withSvgIcon';

export const Filter = withSvgIcon(
  <path
    d="M4 6H8M8 6V4M8 6V8M11 6H20M4 18H8M8 18V16M8 18V20M11 18H20M4 12H16M16 12V10M16 12V14M19 12H20"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="square"
    strokeLinejoin="round"
  />,
  { viewBox: '0 0 24 24' },
);
